const footer = {
  namespaced: true,
  state: {
    links: {
      contactUs: "https://www.cea.gov.sg/contact-info",
      feedback: "https://www.cea.gov.sg/feedback",
      faq: "https://www.cea.gov.sg/faq",
      reportVulnerabilities: "https://www.tech.gov.sg/report_vulnerability",
      privacyPolicy: "https://www.cea.gov.sg/privacy-statement",
      termsOfUse: "https://www.cea.gov.sg/terms-of-use",
      rateThisWebsite: "https://www.cea.gov.sg/rate-our-website"
    }
  }
};

export default footer;
